





































































import { FieldDescription } from "@/model/entity/field-descriptor"
import ACTIVITY_TYPE, { activityTypeList } from "@/model/entity/activity-history/activity-type"
import { activityHistoryService, IActivityHistoryService } from "@/model/service/activity-history/activity-history-service"
import Datatable, {DatatableOptions, FilterContainer, IDatatable} from "@/components/datatable/Datatable.vue"
import ActivityHistory from "@/model/entity/activity-history/activity-history"
import Vue from "vue"
import moment from "moment"
import { Filter } from "@/model/dto/filter"
import { saveAs } from "file-saver"
import ActivityHistoryDetail from "./ActivityHistoryDetail.vue"
import { ExportLogService } from "@/model/service/activity-history/export-log-service"

interface ActivityHistoryData {
  activeHistoryService: IActivityHistoryService
  options: DatatableOptions
  activityTypeList: ACTIVITY_TYPE[]
  fields: FieldDescription[]
  filters: FilterContainer,
  loading: boolean
  selectedActivity: ActivityHistory | null,
}

const activityHistory = Vue.extend({
  components: {
    Datatable,
    ActivityHistoryDetail
  },
  data(): ActivityHistoryData {
    return {
      activeHistoryService: activityHistoryService,
      options: {
        operations: {
        }
      },
      activityTypeList,
      fields: ActivityHistory.getFieldDescriptionList(),
      filters: {
        creationDate: [
        moment()
          .startOf("day")
          .toDate(),
        moment()
          .endOf("day")
          .toDate()
        ],
        activityTypeEnum: null
      },
      loading: false,
      selectedActivity: null
    }
  },
  computed: {
    datatable(): IDatatable {
      return this.$refs.table as IDatatable
    }
  },
  methods: {
    setActivityType() {
      this.datatable.refreshData()
    },
    setDateFilter() {
      if (this.filters.creationDate) {
        this.filters.creationDate = [
          moment(this.filters.creationDate[0])
            .startOf("day")
            .toDate(),
          moment(this.filters.creationDate[1])
            .endOf("day")
            .toDate()
          ]
      }
      this.datatable.refreshData()
    },
    handleFilter(filters) {
      let filterList = filters

      filterList = filterList.map(filter => {
        if (filter.field && filter.field === "creationDateTo") {
          filter.field = "endTime"
        } else if (filter.field && filter.field === "creationDateFrom") {
          filter.field = "startTime"
        }
        return filter
      })

      if (this.filters.activityTypeEnum) {
        filterList = [...filters,
         new Filter("activityType", this.filters.activityTypeEnum)
        ]
      }

      return filterList
    },
    showDetails(activityHistory: ActivityHistory) {
      this.selectedActivity = activityHistory
    },
    async download(activityHistory: ActivityHistory) {
      const service = activityHistory.getExportLogService() as ExportLogService

      const params = new Map()
      params.set("activityHistoryId", activityHistory.id)

      this.loading = true

      const { blob, filename } = await service.exportCsv(params)
      saveAs(blob, filename)
      this.loading = false
    },
    onClose() {
      this.selectedActivity = null
    }
  }
})

export default activityHistory
